import { __assign } from 'tslib';
import * as React from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { UitkListItem, UitkList } from 'uitk-react-list';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';
import { UitkHeading, UitkParagraph, UitkText } from 'uitk-react-text';
import { UitkLink } from 'uitk-react-link';

var DisallowedElementsArray = [
    'audio',
    'form',
    'iframe',
    'input',
    'noscript',
    'script',
    'style',
    'textarea'
];

var UitkUnformattedHtml = function (props) {
    var elementsToReplace = props.elementsToReplace, htmlToParse = props.htmlToParse, PlainTextElement = props.plainTextElement;
    var parseOptions = {
        replace: function (domNode) {
            var children = domNode.children, attribs = domNode.attribs, name = domNode.name;
            var generateChildren = function () { return React.createElement(React.Fragment, null, domToReact(children, parseOptions)); };
            if (elementsToReplace === null || elementsToReplace === void 0 ? void 0 : elementsToReplace.hasOwnProperty(name)) {
                var Component = elementsToReplace[name];
                var attrsToProps = attributesToProps(attribs);
                return React.createElement(Component, __assign({}, attrsToProps), generateChildren());
            }
            if (DisallowedElementsArray.includes(name)) {
                return React.createElement(React.Fragment, null);
            }
        }
    };
    if (htmlToParse) {
        var elements = parse(htmlToParse, parseOptions);
        return (React.createElement(React.Fragment, null, PlainTextElement && elements === htmlToParse ? React.createElement(PlainTextElement, null, elements) : elements));
    }
    else if (props.children) {
        // Backwards compatible addition:
        // If children are passed in, keep old styles
        return React.createElement("div", null, props.children);
    }
    else {
        return null;
    }
};
var headingStyle = function (curriedProps) {
    return function (props) { return (React.createElement(UitkSpacing, { margin: { blockstart: 'four' } },
        React.createElement(UitkHeading, __assign({}, props, curriedProps), props.children || null))); };
};
var UitkUnformattedHtmlReplaceDefaults = {
    h1: headingStyle({ size: 1, tag: 'h1' }),
    h2: headingStyle({ size: 2, tag: 'h2' }),
    h3: headingStyle({ size: 3, tag: 'h3' }),
    h4: headingStyle({ size: 4, tag: 'h4' }),
    h5: headingStyle({ size: 5, tag: 'h5' }),
    h6: headingStyle({ size: 6, tag: 'h6' }),
    hr: function () { return React.createElement(UitkSpacingHr, null); },
    li: function (props) { return React.createElement(UitkListItem, null, props.children || null); },
    ol: function (props) { return (React.createElement(UitkSpacing, { margin: { blockstart: 'two' } },
        React.createElement(UitkList, { type: "ordered" }, props.children || null))); },
    p: function (props) { return React.createElement(UitkParagraph, { size: 2 }, props.children || null); },
    ul: function (props) { return (React.createElement(UitkSpacing, { margin: { blockstart: 'two' } },
        React.createElement(UitkList, null, props.children || null))); },
    a: function (props) {
        var children = props.children, href = props.href;
        return (React.createElement(UitkLink, null,
            React.createElement("a", { href: href }, children)));
    }
};
UitkUnformattedHtml.defaultProps = {
    elementsToReplace: UitkUnformattedHtmlReplaceDefaults,
    plainTextElement: function (props) { return React.createElement(UitkText, { size: 300 }, props.children || null); }
};

export { UitkUnformattedHtml, UitkUnformattedHtmlReplaceDefaults };
